document.addEventListener("DOMContentLoaded", function () {
    /** ColorSwatch click */
    function addColorSwatchClickEvent() {
        document.querySelectorAll(".product-card .product-card__info .color-swatch.more").forEach(function (element) {
            element.addEventListener("click", function () {
                const parentElement = element.parentElement;
                if (parentElement) {
                    parentElement.classList.toggle("visible");
                }
            });
        });
    }

    const observer = new MutationObserver(addColorSwatchClickEvent);
    observer.observe(document.body, { childList: true, subtree: true });

    addColorSwatchClickEvent();
});

$('#ki-trigger').on('click', (event) => {
    event.preventDefault();
    $('#sitespeak-launcher').trigger('click');
});

$(document).ready(function () {

    /** Move Announcement-Bar below the Slideshow */

    let announcementMaxWidth = $(':root').css('--announcementbar_maxwidth');

    if (announcementMaxWidth) {
        let announcementMediaQuery = window.matchMedia(`(max-width: ${announcementMaxWidth})`);

        function handleWindowChange(e) {
            if (e.matches) {
                moveAnnouncementDown();
            }
            else {
                moveAnnouncementUp();
            }
        }

        if (announcementMediaQuery && typeof announcementMediaQuery.addListener === 'function') {
            announcementMediaQuery.addListener(handleWindowChange);
            handleWindowChange(announcementMediaQuery);
        }
    }

    function moveAnnouncementDown() {
        const announcementBar = $(".announcement-bar .announcement-bar__carousel .prose.cd");
        const announcementBarParent = $("#announcement-bar-top .announcement-bar .announcement-bar__carousel");
        const mobileAnnouncement = $("#mobil-announcement .announcement-bar.color-scheme .announcement-bar__carousel");

        if (announcementBar.length) {
            if (mobileAnnouncement.length) {
                announcementBar.appendTo(mobileAnnouncement);
            } else {
                announcementBar.remove();
            }

            const children = announcementBarParent.children();

            if (children.length) {
                const hasSelected = children.filter(".is-selected").length > 0;

                if (!hasSelected) {
                    children.first().addClass("is-selected");
                }
            }
        }
    }

    function moveAnnouncementUp() {
        const announcementBar = $(".announcement-bar .announcement-bar__carousel .prose.cd");
        const announcementBarTop = $("#announcement-bar-top .announcement-bar .announcement-bar__carousel");

        if (announcementBar.length && announcementBarTop.length) {
            announcementBar.appendTo(announcementBarTop).show();
        }
    }

    /** Announcement-Bar show */

    $("#announcement-bar-top").show();

    /** Move AI-Button Up if needed */

    const presMo = window.matchMedia("screen and (max-width:699px)");
    let isMobile = false;

    function handleSizeChange(e) {
        if (e === null || e === undefined) {
            return;
        }

        if (e.matches) {
            isMobile = true;
        } else {
            isMobile = false;
        }
    }

    if (presMo !== null && presMo !== undefined) {
        presMo.addListener(handleSizeChange);
        handleSizeChange(presMo);
    }

    const observer = new MutationObserver(function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation === null || mutation === undefined) {
                continue;
            }

            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                if (mutation.target === null || mutation.target === undefined) {
                    continue;
                }

                if (mutation.target.classList.contains('is-visible')) {
                    handleSizeChange(presMo)
                    if (isMobile) {
                        document.documentElement.style.setProperty('--sitespeak-distance', '3.6rem');
                        document.documentElement.style.setProperty('--accessibility-distance', '3.6rem');
                    }
                } else {
                    document.documentElement.style.setProperty('--sitespeak-distance', '0rem');
                    document.documentElement.style.setProperty('--accessibility-distance', '0rem');
                }
            }
        }
    });
    const target = document.querySelector('.product-sticky-bar');
    if (target !== null && target !== undefined) {
        observer.observe(target, { attributes: true });
    }
});

function getVariantIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('variant');
}

function updateVariantPair(baseSelector, variantSelector, variantId) {
    document.querySelectorAll(baseSelector).forEach(el => { el.style.display = 'none'; });
    document.querySelectorAll(variantSelector).forEach(el => { el.style.display = 'none'; });

    let shown = false;
    if (variantId) {
        const targets = document.querySelectorAll(`${variantSelector}[data-variant-id="${variantId}"]`);
        if (targets.length > 0) {
            targets.forEach(el => { el.style.display = 'block'; });
            shown = true;
        }
    }

    if (!shown) {
        document.querySelectorAll(baseSelector).forEach(el => { el.style.display = 'block'; });
    }
}

function updateVariantPairByAttr(baseSelector, variantSelector, variantId, attrName) {
    document.querySelectorAll(baseSelector).forEach(el => { el.style.display = 'none'; });
    document.querySelectorAll(variantSelector).forEach(el => { el.style.display = 'none'; });

    let shown = false;
    if (variantId) {
        const selector = `${variantSelector}[${attrName}="${variantId}"]`;
        const targets = document.querySelectorAll(selector);
        if (targets.length > 0) {
            targets.forEach(el => { el.style.display = 'block'; });
            shown = true;
        }
    }

    if (!shown) {
        document.querySelectorAll(baseSelector).forEach(el => { el.style.display = 'block'; });
    }
}

function updateBadgesByVariant(variantId) {
  document.querySelectorAll('.badges').forEach(block => {
    const productBadges = Array.from(block.querySelectorAll('.product-badge'));
    const variantBadges  = Array.from(block.querySelectorAll('.variant-badge'));

    const seenTitles = new Set();
    productBadges.forEach(badge => {
      const title = (badge.dataset.title || '').trim();
      if (title && !seenTitles.has(title)) {
        badge.style.display = '';
        badge.hidden = false;
        badge.classList.remove('is-hidden');
        seenTitles.add(title);
      } else {
        badge.style.display = 'none';
        badge.hidden = true;
        badge.classList.add('is-hidden');
      }
    });

    variantBadges.forEach(badge => {
      badge.style.display = 'none';
      badge.hidden = true;
      badge.classList.add('is-hidden');
    });

    if (variantId) {
      variantBadges
        .filter(badge => badge.getAttribute('data-id') === variantId)
        .forEach(badge => {
          const title = (badge.dataset.title || '').trim();
          if (title && !seenTitles.has(title)) {
            badge.style.display = '';
            badge.hidden = false;
            badge.classList.remove('is-hidden');
            seenTitles.add(title);
          }
        });
    }
  });
}

function updateVariantDisplay() {
    const variantId = getVariantIdFromUrl();
    updateVariantPair('.product-mf-size-value',  '.variant-mf-size-value',  variantId);
    updateVariantPair('.product-mf-scope-value', '.variant-mf-scope-value', variantId);
    updateBadgesByVariant(variantId);
    updateVariantPair('.rte.teaser-text[data-product-id]', '.rte.teaser-text[data-variant-id]', variantId);
}

document.addEventListener('click', function (event) {
    if (
        event.target.closest('.thumbnail-swatch') ||
        event.target.closest('.popover__value-option') ||
        event.target.closest('.popover__value-list')
    ) {
        setTimeout(updateVariantDisplay, 100);
    }
});

document.addEventListener('DOMContentLoaded', updateVariantDisplay);

(function () {
  function getVariantIdFromHref(href) {
    try {
      const url = new URL(href, window.location.origin);
      return url.searchParams.get('variant');
    } catch (e) {
      return null;
    }
  }

  function updateBadgesForCard(card) {
    const mediaLink = card.querySelector('a.product-card__media');
    if (!mediaLink) return;

    const currentVariantId = getVariantIdFromHref(mediaLink.getAttribute('href') || '');
    const allBadges = card.querySelectorAll('.badge-list .badge');
    const variantBadges = card.querySelectorAll('.badge-list .variant-badge');

    const existingTitles = new Set(
      Array.from(allBadges)
        .filter(b => !b.classList.contains('variant-badge'))
        .map(b => b.dataset.title?.trim())
        .filter(Boolean)
    );

    variantBadges.forEach(badge => {
      const matchesVariant = currentVariantId && badge.dataset.variantId === currentVariantId;
      const title = badge.dataset.title?.trim();
      const isDuplicate = existingTitles.has(title);

      if (matchesVariant && !isDuplicate) {
        badge.style.display = '';
        badge.hidden = false;
        badge.classList.remove('is-hidden');
      } else {
        badge.style.display = 'none';
        badge.hidden = true;
        badge.classList.add('is-hidden');
      }
    });
  }
  function observeCard(card) {
    const attachMediaObserver = () => {
      const mediaLink = card.querySelector('a.product-card__media');
      if (!mediaLink) return null;

      const mo = new MutationObserver(mutations => {
        for (const m of mutations) {
          if (m.type === 'attributes' && m.attributeName === 'href') {
            updateBadgesForCard(card);
          }
        }
      });
      mo.observe(mediaLink, { attributes: true, attributeFilter: ['href'] });
      return mo;
    };

    updateBadgesForCard(card);
    let mediaObserver = attachMediaObserver();

    const cardObserver = new MutationObserver(() => {
      if (mediaObserver) mediaObserver.disconnect();
      mediaObserver = attachMediaObserver();
      updateBadgesForCard(card);
    });

    cardObserver.observe(card, { childList: true, subtree: true });
  }

  function init() {
    document.querySelectorAll('product-card').forEach(observeCard);

    const rootObserver = new MutationObserver((mutations) => {
      mutations.forEach(m => {
        m.addedNodes && m.addedNodes.forEach(node => {
          if (node.nodeType === 1) {
            if (node.matches && node.matches('product-card')) {
              observeCard(node);
            } else {
              node.querySelectorAll && node.querySelectorAll('product-card').forEach(observeCard);
            }
          }
        });
      });
    });
    rootObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
